import { fetchWithRetry } from '../utils/ApiHelper'

export async function submitRace(raceEntryData) {
    try {
        const playerElos = await addElo(raceEntryData['racePlayers']);

        // Add 'elo' values back to the original players in raceEntryData
        raceEntryData['racePlayers'] = raceEntryData['racePlayers'].map((player) => {
            const matchingPlayer = playerElos.find((elos) => elos.playerId === player.playerId);
            if (matchingPlayer) {
                return { ...player, elo: matchingPlayer.elo };
            }
            return player;
        });

        const headers = { 'content-type': 'application/json' };

        const requestOptions = {
            method: 'POST',
            headers,
            body: JSON.stringify(raceEntryData),
        };

        const response = await fetchWithRetry(`${process.env.REACT_APP_BACKEND_ADDRESS || ""}/api/races`, requestOptions);

        if (!response.ok) {
            // Handle non-2xx HTTP responses
            throw new Error(`Failed to submit race: ${response.statusText}`);
        }

        // Parse and return the JSON response to the caller
        const result = await response.json();
        return { status: response.status, data: result }; // Return both status and data
    } catch (error) {
        console.error('Error submitting race:', error);
        throw error; // Re-throw the error so the caller can handle it
    }
}


async function addElo(playerData) {
    try {
        const playerIds = playerData.map((player) => player.playerId).join(',');
        const headers = {};

        const response = await fetchWithRetry(`${process.env.REACT_APP_BACKEND_ADDRESS || ""}/api/players/elo/${playerIds}`, { headers });

        if (!response.ok) {
            throw new Error(`Failed to fetch Elo ratings: ${response.statusText}`);
        }

        const updatedPlayers = await response.json();
        return updatedPlayers;
    } catch (error) {
        console.error('Error fetching Elo ratings:', error);
        throw error;
    }
}
